import { useContext } from "react";
import { LicenseInvoicePlanListInfo } from "../../../../../generated/data-contracts";
import { api, IAxiosError } from "../../../../../utils";
import { AvisDataTable } from "../../../../shared/components/table";
import { AvisContext } from "../../../../shared/context/AvisContext";
import {
  columnConfigLicenseReports,
  conditionalFormattingReportDue,
} from "../ColumnConfigLicenseReports";

interface IActualReportsGridProps {
  setError: React.Dispatch<React.SetStateAction<IAxiosError | undefined>>;
  onDataLoaded?: (data: LicenseInvoicePlanListInfo[]) => void;
}
export function ActualReportsGrid(props: Readonly<IActualReportsGridProps>) {
  const { setError, onDataLoaded } = props;
  const { res } = useContext(AvisContext);

  const columnMetadata = columnConfigLicenseReports(undefined, res);

  return (
    <AvisDataTable<LicenseInvoicePlanListInfo>
      setError={setError}
      getApiData={() => api.licenseesGetLicenseInvoicePlans()}
      columnMetadata={columnMetadata}
      columnWidths={[12, 33, 15, 10, 10, 20]}
      conditionalFormatting={[conditionalFormattingReportDue]}
      onDataLoaded={onDataLoaded}
    />
  );
}
